import type { TFilterOption } from "../model/filterTypes"

export const countFilterItems = (filter: TFilterOption[]) => {
    let counter = 0

    filter.forEach(({ items }) => items.forEach(() => counter++))

    return counter
}
